import Button from "../base/Button";

const renderIcon = (color) => (
    <svg width="34px" height="33px" viewBox="0 0 34 33" version="1.1">
        <title>search</title>
        <desc>Created with Sketch.</desc>
        <defs />
        <g
            id="Symbols---Zep"
            stroke="none"
            strokeWidth="1"
            fill="none"
            fillRule="evenodd"
            strokeLinecap="square"
        >
            <g
                id="LS-Menu"
                transform="translate(-283.000000, -13.000000)"
                stroke={color}
            >
                <g id="search">
                    <g transform="translate(283.750000, 14.000000)">
                        <path d="M32,32 L23.5789474,23.5789474" id="Shape" />
                        <circle
                            id="Oval"
                            cx="13.4736842"
                            cy="13.4736842"
                            r="13.4736842"
                        />
                    </g>
                </g>
            </g>
        </g>
    </svg>
);

/**
 * Toolbar button for the search tool.
 *
 * @param props - The base toolbar button props.
 * @returns The rendered search button.
 */
const SearchButton = (props) => <Button {...props} renderIcon={renderIcon} />;

export default SearchButton;
